import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../style.scss";

function ListIntegration(props) {
  const location = useLocation();
  const [integrations, setIntegrations] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchResponse = await axios({
          method: "GET",
          url: props.chimeraserv.urlMozrest + "/mozrest/apikey/",
          headers: {
            Authorization: props.user.data.usrKey,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        console.log("Fetched Mozrest Integrations:", fetchResponse.data);
        setIntegrations(fetchResponse.data.keys || []);
      } catch (error) {
        setIntegrations([]);
      }
    };
    fetchData();
  }, [props.chimeraserv.urlGet]);

  const toggleView = (integrationId) => {
    setExpandedId(expandedId === integrationId ? null : integrationId);
  };

  const toggleStatus = async (integration) => {
    try {
      const response = await axios({
        method: "POST",
        url: `${props.chimeraserv.urlMozrest}/mozrest/apikey/${integration.venueId}/toggle-status`,
        headers: {
          Authorization: props.user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (response.data.success) {
        // Update the local state with the new status
        setIntegrations((prev) =>
          prev.map((item) =>
            item._id === integration._id
              ? { ...item, status: response.data.record.status }
              : item
          )
        );
      }
    } catch (error) {
      console.error("Error toggling status:", error);
      alert("Failed to update status. Please try again.");
    }
  };

  const calculateRemainingDays = (expiryDate) => {
    if (!expiryDate) return null;

    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    const remainingDays = Math.floor(
      (expiry - currentDate) / (1000 * 60 * 60 * 24)
    );
    // const remainingDays = 365 - daysSinceSubscription;

    return remainingDays;
  };

  return (
    <div className="integration-list-page">
      <h2 className="viewTitle">Integrations</h2>
      <div className="integration-grid">
        {integrations.length > 0 ? (
          integrations.map((integration) => (
            <div className="integration-card" key={integration._id}>
              <div className="integration-header">
                <span className="integration-name">{integration.venueId}</span>
                {props.user.data.level === 0 && (
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={integration.status === "active"}
                      onChange={() => toggleStatus(integration)}
                    />
                    <span className="slider"></span>
                  </label>
                )}
              </div>

              {expandedId === integration._id && (
                <div
                  className="integration-details"
                  style={{
                    marginTop: "15px",
                    padding: "15px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Venue ID:</strong> {integration.venueId}
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <strong>API Key:</strong>
                    <span
                      style={{
                        wordBreak: "break-all",
                        fontFamily: "monospace",
                        fontSize: "0.9em",
                        marginLeft: "5px",
                      }}
                    >
                      {integration.apiKey}
                    </span>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Status:</strong>{" "}
                    <span
                      style={{
                        color:
                          integration.status === "active"
                            ? "#28a745"
                            : "#dc3545",
                        fontWeight: "bold",
                      }}
                    >
                      {integration.status || "N/A"}
                    </span>
                  </div>
                  {integration.expiryDate && (
                    <>
                      <div style={{ marginBottom: "10px" }}>
                        <strong>Expiry Date:</strong>{" "}
                        {new Date(integration.expiryDate).toLocaleString()}
                      </div>
                      <div style={{ marginBottom: "10px" }}>
                        <strong>Remaining Days:</strong>{" "}
                        <span
                          style={{
                            color:
                              calculateRemainingDays(integration.expiryDate) >
                              30
                                ? "#28a745"
                                : calculateRemainingDays(
                                    integration.expiryDate
                                  ) > 0
                                ? "#ffc107"
                                : "#dc3545",
                            fontWeight: "bold",
                          }}
                        >
                          {calculateRemainingDays(integration.expiryDate)} days
                          {calculateRemainingDays(integration.expiryDate) <=
                            0 && " (Expired)"}
                        </span>
                      </div>
                    </>
                  )}
                  {integration.createdAt && (
                    <div style={{ marginBottom: "10px" }}>
                      <strong>Created:</strong>{" "}
                      {new Date(integration.createdAt).toLocaleString()}
                    </div>
                  )}
                  {integration.updatedAt && (
                    <div>
                      <strong>Updated:</strong>{" "}
                      {new Date(integration.updatedAt).toLocaleString()}
                    </div>
                  )}
                </div>
              )}

              <div className="integration-actions">
                {props.user.data.level === 0 && (
                  <Link
                    to={
                      location.pathname.split("/").splice(0, 3).join("/") +
                      "/edit/" +
                      integration._id
                    }
                    state={{ data: integration }}
                    className="action-btn"
                  >
                    <FontAwesomeIcon icon={["fas", "cog"]} /> Edit
                  </Link>
                )}
                <button
                  onClick={() => toggleView(integration._id)}
                  className="action-btn"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    color: "inherit",
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      "fas",
                      expandedId === integration._id ? "eye-slash" : "eye",
                    ]}
                  />
                  {expandedId === integration._id ? " Hide" : " View"}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-integrations">No integrations found.</div>
        )}
      </div>
    </div>
  );
}

export default ListIntegration;
